
import React from 'react';
import ConditionPageTemplate from './ConditionPageTemplate';

const FinesLinesWrinkles = () => {
  const treatments = [
    {
      name: "Botox",
      href: "/treatments/botox",
      description: "Smooth expression lines while preserving natural movement",
      price: "$299",
      memberPrice: "$199"
    },
    {
      name: "Skin Tightening Laser",
      href: "/treatments/skin-tightening",
      description: "Non-invasive collagen stimulation for firmer skin",
      price: "$550",
      memberPrice: "$399"
    },
    {
      name: "RF Microneedling",
      href: "/treatments/rf-microneedling",
      description: "Boost collagen production for long-term anti-aging",
      price: "$649",
      memberPrice: "$499"
    },
    {
      name: "PRF & Peptides",
      href: "/treatments/prf",
      description: "Natural regenerative treatment using your own platelets",
      price: "$449",
      memberPrice: "$349"
    }
  ];

  return (
    <ConditionPageTemplate
      title="Fine Lines & Wrinkles"
      subtitle="Turn Back Time, Not Your Expression"
      description="We treat early fine lines to deeper wrinkles with injectables and collagen-boosting therapies — no frozen faces, just refreshed glow. Perfect for expression lines, crow's feet, and forehead wrinkles."
      treatments={treatments}
      beforeAfterText="Glow members receive bonus units every visit. Results visible within 3-14 days."
    />
  );
};

export default FinesLinesWrinkles;
